import { triggerSimpleAjax } from '../../helpers/httpHelper';
import { GET_ENROLLEMENT_FORM } from '../../helpers/constants/apiUrl';
import { AppConfig } from '../../app-config';

export function getEnrollmentForm(req = '') {    
    return new Promise((res, rej) => {
        const url = `${GET_ENROLLEMENT_FORM}${req}`;
        triggerSimpleAjax(
            url,
            'GET',
            {},
            (response) => {
                res(response);
            },
            (error) => {
                rej(error);
            }
        );
    });
}